import { Attraction } from '@/types/attractions/attractions';
import { attractions } from '@/constants/constants';
import { User } from '@/types/User/type';

export const TRIP_REF = '6SMFOA';
export const GUEST: User = {
  id: 'Guest',
  name: 'Guest',
  inOutScore: 3,
  leisureThrillScore: 3,
  cheapExpScore: 3,
};

export const users: User[] = [
  {
    id: '2',
    name: 'Luxurious & Indoorsy User',
    inOutScore: 1,
    leisureThrillScore: 3,
    cheapExpScore: 5,
    email: 'LuxuriousIndoor@gmail.com',
    password: 'asdasd',
  },
  {
    id: '72',
    name: 'Luxurious & Outdoorsy User',
    inOutScore: 5,
    leisureThrillScore: 3,
    cheapExpScore: 5,
    email: 'LuxuriousOutdoor@gmail.com',
    password: 'asdasd',
  },
  {
    id: '18',
    name: 'Neutral User',
    inOutScore: 3,
    leisureThrillScore: 3,
    cheapExpScore: 3,
    email: 'Neutral@gmail.com',
    password: 'asdasd',
  },
  {
    id: '80',
    name: 'Conservative & Outdoorsy User',
    inOutScore: 5,
    leisureThrillScore: 3,
    cheapExpScore: 1,
    email: 'ConservativeOutdoor@gmail.com',
    password: 'asdasd',
  },
  {
    id: '10',
    name: 'Conservative & Indoorsy User',
    inOutScore: 1,
    leisureThrillScore: 3,
    cheapExpScore: 1,
    email: 'ConservativeIndoor@gmail.com',
    password: 'asdasd',
  },
];

export const dummyAttractions: Attraction[] = [
  {
    id: 1,
    category: attractions.tours,
    rating: 3.5,
    description:
      'A new pandemic is spreading quickly, sweeping the world with a high mortality rate. Scientists term this deadly plague "Green Death-29". Now, almost all on the main island are infected. Sentosa and St John`s Island are one of the few areas the virus has not yet ravaged.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/escape-from-st-johns-island/0531-0152_escape-from-st-johns-island-singapore-pelago0-large.webp',
    price: '745',
    title: "Escape from St John's Island: Survivor-style Adventure",
  },

  {
    id: 2,
    category: attractions.dining,
    rating: 3.6,
    description:
      "From China to the Philippines, people love popiah (a Fujianese/Teochew-style fresh spring roll). And it has found a special place in the heart of Singaporeans too. In this activity, discover popiah's heritage and learn how to make this traditional dish.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/local-culinary-tour-i-asia-travel-management/0112-0300_local-culinary-tour-i-asia-travel-management-pelago1-large.webp',
    price: '666',
    title: 'Hawker Hero at a Traditional Popiah and Kopi Class',
  },

  {
    id: 3,
    category: attractions.activities,
    rating: 3.7,
    description:
      "It's time to go glamping! Escape to a tranquil pocket of nature nestled in the heart of Bukit Timah, and camp out under a blanket of stars in ultimate luxury. Spend time with your loved ones reconnecting with Mother Nature in the comfort of a roomy modern tent.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/glamping-bukit-timah-horsecity/1117-0528_glamping-bukit-timah-horsecity-singapore-pelago0-large.webp',
    price: '441',
    title: 'Meet Ponies and Horses in a Nature Glamping Adventure',
  },

  {
    id: 4,
    category: attractions.dining,
    rating: 3.7,
    description:
      'Join us on this fascinating craft beer tour where you will discover how RedDot BrewHouse perfected their craft for over a decade while witnessing firsthand the brewing tanks and equipment specially designed by us and sample our new seasonal beers paired with scrumptious food.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/heartland-craft-beer-reddot-brewhouse/0804-0446_heartland-craft-beer-reddot-brewhouse-singapore-pelago5',
    price: '724',
    title: 'Local Craft Brewery with Craft Beer Appreciation',
  },

  {
    id: 5,
    category: attractions.tours,
    rating: 3.7,
    description:
      "What's better than exploring Singapore on foot? Zipping past city streets in a Vespa sidecar, that's for sure. With this tour, breeze through heritage areas like Kampong Glam, Little India, and Chinatown. Admire the slick Singapore skyline, crowned by the iconic Marina Bay Sands hotel, as well as check out classical colonial Victorian buildings of the Civic District, and Bras Basah.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/singapore-in-a-nutshell-tour-singapore-sidecars/0112-0301_singapore-in-a-nutshell-tour-singapore-sidecars-singapore-pelago2-large.webp',
    price: '528',
    title: 'Explore Singapore in a Vintage Vespa Sidecar',
  },

  {
    id: 6,
    category: attractions.tours,
    rating: 3.4,
    description:
      "Once upon a time, fishing boats lined the Singapore River. Now, that same river meanders through a buzzing city that's brimming with modernity, culture, and jaw-dropping architecture. With this tour, take a relaxing stroll around the Civic District and listen to inspiring stories of a resilient nation that fought against all the odds to become a First World country.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/private-singapore-city-sightseeing-walking-tour-monster-day-tours/0112-0301_private-original-singapore-city-sightseeing-walking-tour-monster-day-tours-singapore-pelago10-large.webp',
    price: '424',
    title: 'Journey From Third World to First at City Hall',
  },

  {
    id: 7,
    category: attractions.dining,
    rating: 4.1,
    description:
      'Travel the world on your palate. Relish.SG presents a feast for globetrotting gourmands. Enjoy exotic flavours and textures in the comfort of Singapore home. From Bombay to Madrid, enjoy a culinary journey through unique and delicious interpretation of classic dishes.',
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/ph1234567/0413-0222_spelago2',
    price: '486',
    title: "Taste The World's Flavours Curated By Chef-Historian",
  },

  {
    id: 8,
    category: attractions.activities,
    rating: 3.2,
    description:
      "Get in touch with nature and enjoy a dose of excitement at the same time courtesy of a cycling trip around Pulau Ubin, Singapore's most popular island. Following that, perform your best Terminator impression with laser clay shooting. Go full-on Counter-Strike mode and hit targets",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/cycling-pulau-ubin-laser-clay-land-zovb-adventour/0112-0259_laser-clay-shooting-adventour-singapore-pelago5-large.webp',
    price: '653',
    title: 'Enjoy Cycling at Pulau Ubin, Zorbing, and Clay Shooting',
  },

  {
    id: 9,
    category: attractions.dining,
    rating: 3.4,
    description:
      "Put the woke in \"woke hei\" at HolyCrab, a forerunner of Singapore's private dining scene where diners used to fill their bellies in Chef Elton's humble abode. Now a large industrial kitchen, enjoy a small group hands-on experience outta-the-ol'-home.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/holycrab-wok-hei-kitchen/0221-0749_holycrab-wok-hei-kitchen-singapore-pelago1-large.webp',
    price: '318',
    title: 'Art of Wok Hei at HolyCrab',
  },

  {
    id: 10,
    category: attractions.tours,
    rating: 4.4,
    description:
      "Think you've seen (and know) all of Singapore? Think again. Go on this four-hour bicycle tour to visit iconic attractions and venues like Merlion Park, Haji Lane, the F1 Race Track, and Chinatown, but get ready to learn way more than what you've read online",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/lion-city-bike-tour/0613-0459_lion-city-bike-tour-bike-around-tour-pelago0.jpg',
    price: '227',
    title: 'Singapore Lion City Bicycle Tour',
  },

  {
    id: 11,
    category: attractions.tours,
    rating: 3.6,
    description:
      "Explore the lesser known sights of Seletar, from its black and white colonial houses which housed Royal Air Force personnel, to Singapore's first wetlands sanctuary in an industrial park. Hunt down retired colonial steel and goose-necked lamp posts, and gawk at sheltered walkways that resemble wings of aircraft.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/seletar-aviation-hangar-tour/0421-1059_seletar-aviation-hangar-tour-singapore-pelago0-large.webp',
    price: '322',
    title: 'Fascinating World of Aviation with Exclusive Hangar Tour',
  },

  {
    id: 12,
    category: attractions.dining,
    rating: 4.3,
    description:
      "Take a deep dive into a cup of coffee on Singapore's only live coffee roasting experience. Brew the freshest cuppa from scratch in a 1.5-hour workshop. Perfect for casual caffeine enthusiasts, this workshop explores the origins and expressions of coffee.",
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/coffee/0715-0731_0-large.webp',
    price: '125',
    title: 'Coffee Roasting Barista at a Desert-themed Bar',
  },

  {
    id: 13,
    category: attractions.activities,
    rating: 4.9,
    description:
      "Sail past Sentosa's white-sand beaches aboard The Royal Albatross. Pamper your significant other to an evening of luxury. And enjoy a delectable three-course dinner as you take in unparalleled views of Singapore's skyline at sunset.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/tallship-sunset-sail-dinner-cruise/0112-0302_tall-ship-sunset-dinner-cruise-singapore-pelago-1.jpg',
    price: '196',
    title: 'Sail On a Luxury Superyacht From Sentosa',
  },

  {
    id: 14,
    category: attractions.dining,
    rating: 4.4,
    description:
      "Indulge in boldly-flavoured toothsome, tender steaks in a unique tasting session at An Ox Box, a private home-based dining experience famed for carving its niche in dry aged beef. You'll sample an exciting variety of dry aged steaks cooked to perfection using the sous vide method. Enjoy an incredible depth of flavours as you chow down on premium beef for an unparalleled carnivorous dinner affair, and share the experience with your friends.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/an-ox-box-home-dining/1130-0822_an-ox-box-home-dining-singapore-pelago00-large.webp',
    price: '123',
    title: 'Savour Dry Aged Beef in a Private Home dining Experience',
  },

  {
    id: 15,
    category: attractions.tours,
    rating: 3.8,
    description:
      'Feel the pulse of the city on this popular Singapore city highlights tour. Stroll along the scenic Singapore River and admire old colonial architecture. Marvel at the contrast between old shophouses and gleaming skyscrapers. Listen to inspiring stories of the local people.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/city-highlights-singapore-river-marina-bay/0720-0638_city-highlights-singapore-river-marina-bay-singapore-pelago0-large.webp',
    price: '235',
    title: 'City Highlights Tour of Singapore River and Marina Bay',
  },

  {
    id: 16,
    category: attractions.tours,
    rating: 3,
    description:
      'Joo Chiat is a treasure trove of great hidden food gems in Singapore. Discover the best of this heritage neighbourhood with your guide, a true blue Peranakan Katong boy, Anthony. Dive deep into Joo Chiat on a wonderful journey that will engage all your senses, especially your taste buds!',
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/joo-chiat-food-tour/0531-0140_joo-chiat-food-tour-singapore-pelago0.jpg',
    price: '240',
    title: 'Eat Your Way Through Joo Chiat: Singapore Food Tour',
  },

  {
    id: 17,
    category: attractions.dining,
    rating: 4.8,
    description:
      "From wet market to gin bottle, join the Tanglin team as they take you on a journey through Singapore's original gin distillery, where you can taste locally sourced ingredients, as well as learn the processes of distillation, from mixing to bottling. After the tour, savour four different Tanglin Gin expressions, followed by a bespoke gin and tonic cocktail.",
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/tanglin-gin-distillery-tour/1201-0524_tanglin-gin-1-large.webp',
    price: '59',
    title: 'Local Gin Distillery Tour at Tanglin Gin Singapore',
  },

  {
    id: 18,
    category: attractions.activities,
    rating: 4.3,
    description:
      'Have you been feeling stressed lately? Or are you suffering from burnout of some sort? Perhaps you may feel mentally exhausted without even knowing why. If you can relate, try learning mindfulness and meditation from Yvette Tee, an experienced, inspirational, and compassionate meditation teacher. Over the last ten years, she has taught and hosted hundreds of meditation',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/virtual-meditation-mindfulness-yvette-class/0915-0348_virtual-meditation-mindfulness-yvette-class-singapore-pelago0.jpg',
    price: '61',
    title: 'Learn Mindfulness with Yvette, a Renowned Meditation Coach',
  },

  {
    id: 19,
    category: attractions.dining,
    rating: 3.8,
    description:
      'Embark on a captivating Singa-pour gin journey with Brass Lion as gin enthusiasts take you on a guided tasting of a flight of 6 uniquely Brass Lion gins. Discover what goes into the gin making process and the inspiration behind them, which will change your ways of appreciating gin.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/brass-lion-distillery-tour-singapore-sling-masterclass/0112-0259_brass-lion-distillery-tour-singapore-sling-masterclass-singapore-pelago3-large.webp',
    price: '53',
    title: 'Locally-Distilled Gin at Brass Lion Distillery',
  },

  {
    id: 20,
    category: attractions.tours,
    rating: 4.1,
    description:
      "Hop on a bicycle and pedal down the Marina Bay district on a beautiful sunset journey with trained guides. Traverse through towering skyscrapers, weave your way through ultra-futuristic buildings, lap up all the sights and sounds, and discover stories about how Marina Bay came to be Singapore's glitziest hood.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/marina-bay-night-tour-by-lets-go-tour-singapore/0112-0300_marina-bay-night-tour-by-lets-go-tour-singapore-pelago1-large.webp',
    price: '79',
    title: 'Night Cycling Tour in Marina Bay, Singapore',
  },

  {
    id: 21,
    category: attractions.tours,
    rating: 4.1,
    description:
      'Do you have what it takes to tackle The Jewel Heist? Set in the iconic Jewel Changi Airport, play this thrilling heist in teams of four to six. Participants will work as a team through missions set forth by the leader of the activity - your guide and gamemaster.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/jewel-changi-airport-heist/0715-0244_jewel-changi-airport-heist-singapore-pelago0',
    price: '52',
    title: 'Jewel Heist at Jewel Changi Airport',
  },

  {
    id: 22,
    category: attractions.dining,
    rating: 4.9,
    description:
      'Tea Lounge at Regent Singapore goes back to the most quintessential of English customs – the tradition of afternoon tea. This elegant establishment takes cues from the rolling hills of the English countryside with a selection comprising dainty sandwiches and delicate scones to be savoured elegantly with fine teas.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/weekday-afternoon-tea-regent/0416-0354_tea-lounge-regent-singapore-pelago1.jpg-large.webp',
    price: '54',
    title: 'Luxe Afternoon Tea Set at Regent Singapore',
  },

  {
    id: 23,
    category: attractions.activities,
    rating: 3.4,
    description:
      'Drinking and driving is a big no-no. But what if you could have the best of both worlds? Well, thanks to Singapore Sidecars, that`s a reality. Scoot through some of Singapore`s hippest hoods, have your fill of alcohol and grub, and get driven back home safely in a vintage Vespa sidecar',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/you-drink-we-drive-singapore-sidecars/0112-0302_you-drink-we-drive-singapore-sidecars-singapore-pelago1.jpg',
    price: '61',
    title: "You Drink, They'll Drive You in a Vintage Vespa Sidecar",
  },

  {
    id: 24,
    category: attractions.dining,
    rating: 3.1,
    description:
      'Explore the heritage area around Tiong Bahru market, and taste the history and culture of wrapped food. Why did people use particular leaves or specific plants to wrap food? Was it for taste? Or preservation? Find the answers to these questions and more by sampling otak otak (grilled fish cake), lotus leaf rice, dumplings, and Nyonya kueh (bite-sized snack).',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/placeholder79/0223-0642_its-a-wrap-fragrant-and-sustainable-traditions-from-yesteryear--1-large.webp',
    price: '72',
    title: 'Learn the Culture of Wrapped Foods',
  },

  {
    id: 25,
    category: attractions.tours,
    rating: 3.5,
    description:
      "Join your guide Andros, whose magical yin yang eyes allow him to view the world differently. Andros is a journalist on a task to investigate the soul of Singapore's vibrant Chinatown through its statutes, murals, shops and soups. Uncover the unique characteristics of Chinatown through the stories of the people who lived there.",
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/yinyang/0530-0556_0-large.webp',
    price: '41',
    title: 'Yin Yang Soul of Chinatown Walking Tour in Singapore',
  },

  {
    id: 26,
    category: attractions.tours,
    rating: 3,
    description:
      'The Ferryman, a policeman from the netherworld, needs your help to locate the scattered body parts of a Japanese doll. Only with the parts as a whole, can the spirit of the doll be freed.',
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/thedoll/0530-0633_3-medium.webp',
    price: '38',
    title: 'The Doll Scavenger Hunt: Little India Walking Tour',
  },

  {
    id: 27,
    category: attractions.dining,
    rating: 4.4,
    description:
      'The 1925 Brewing Co. is a Singaporean brewery that focuses on creating Asian-styled beers for the Asian palate. Embark on an exciting tour where you can find out more about how this microbrewery brews their beers, get close to their brewing tanks, and sample never-before-released brews.',
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/the-1925-brewing-co-brewery-tour/0112-0302_1925-brewery-pelago1-large.webp',
    price: '34',
    title: 'Asian-Styled Beers at The 1925 Brewing Co.',
  },

  {
    id: 28,
    category: attractions.activities,
    rating: 4.7,
    description:
      'Once upon a time, only available in New Zealand, ZOVBing (pronounced as zorbing) is now available in Singapore thanks to advenTOUR. How it works is that you strap yourself in a gigantic plastic air-cushioned ball and roll down a gentle slope for the ultimate anti-gravity adrenaline rush.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/land-zovb-adventour/0112-0300_land-zovb-adventour-singapore-pelago1-large.webp',
    price: '43',
    title: 'Zorb Down a Slope for Some Anti-Gravity Fun',
  },

  {
    id: 29,
    category: attractions.dining,
    rating: 4.6,
    description:
      'From coffee shops in the heartlands to bars across town, Tiger Beer is synonymous with Singapore’s drinking culture. But how well do you actually know this iconic brand? Explore each stage of this award-winning beer’s brewing process, from milling and mashing to how the beer is stored and filtered. End your tour at the retro-style Tiger Tavern, and try out fresh beer, including ABC, Anchor, Archipelago Brewery, and Heineken.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/tiger-beer-brewery-tour/0808-0754_tiger_brewery_tour_singapore_singapore_pelago0-large.webp',
    price: '36',
    title: 'Tiger Brewery Singapore',
  },

  {
    id: 30,
    category: attractions.tours,
    rating: 4.6,
    description:
      "Discover the sights and sounds of Singapore. Explore the city's most iconic landmarks from the comfort of your seat on board an open-top, double-decker bus. Enjoy a tour aboard the Big Bus, your one-stop-shop vehicle for checking out the best that Singapore has to offer.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/singapore-big-bus-tour-ticket/0210-0900_singapore-big-bus-tour-ticket-singapore-pelago1-large.webp',
    price: '43',
    title: 'Big Bus tours Singapore',
  },

  {
    id: 31,
    category: attractions.tours,
    rating: 4.9,
    description:
      'The Chinese Singaporean identity today is a result of generations of intercultural influences. Through a walking trail of buildings, arts and food, embark on a journey of discovery.',
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/inside/0530-0746_0-large.webp',
    price: '28',
    title: 'Singaporean Chinese Cultural Walking Trail in Telok Ayer',
  },

  {
    id: 32,
    category: attractions.dining,
    rating: 3.5,
    description:
      "Beyond the lattes, bubble tea, and matcha frappes of today, is our local coffee and tea culture forgotten? Discover the good old days of our kopi (coffee) and cha (teas). And explore the role these beverages played in the everyday lives of Singapore's early immigrants. You will never see your kopi c or teh o the same way again.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/kopi-&-cha-bitter-brews-with-a-story/0219-0618_kopi-&-cha-bitter-brews-with-a-story-pelago-singapore4-large.webp',
    price: '28',
    title: 'Kopi & Cha: A Local Coffee and Tea',
  },

  {
    id: 33,
    category: attractions.activities,
    rating: 3.7,
    description:
      "What do you get by pouring acrylic paint onto a blank canvas? Nothing but beautiful abstract art. At Room to Imagine's Acrylic Pour Discovery Workshop, learn the mesmerising process of drizzling acrylic paint, channel your creativity, and form visually-stunning effects that will dazzle.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/acrylic-pour-discovery-workshop-at-room-to-imagine/0114-0340_acrylic-pour-discovery-workshop-at-room-to-imagine-singapore-pelago2',
    price: '22',
    title: 'Create Beautiful Abstract Art with Acrylic Pouring',
  },

  {
    id: 34,
    category: attractions.dining,
    rating: 4,
    description: 'Its LiHO! Singapore home made brand of LIHO Tea. Bubbles is bubbles! :)',
    imgUrl:
      'https://res.klook.com/image/upload/u_activities:sl3hotrdflmgpql7qux9,h_1.0,ar_960:460,c_scale,e_blur:10000/c_fill,w_960,h_460,f_auto/w_80,x_15,y_15,g_south_west,l_Klook_water_br_trans_yhcmh3/activities/sl3hotrdflmgpql7qux9.webp',
    price: '12',
    title: 'LiHO Tea',
  },

  {
    id: 35,
    category: attractions.tours,
    rating: 3.2,
    description:
      "Embark on an hour-long adventure with a unique city tour of the harbour and the historic Civic District. Seat yourself in a refurbished Vietnam War amphibious vehicle re-designed like an adorable duck. Splash into the water, be ferried around Singapore's best sights and enjoy a tour full of iconic landmarks, heritage, and culture.",
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/bnmbnmbnm/0504-0203_1',
    price: '15',
    title: 'The Original DUCKtours Singapore',
  },

  {
    id: 36,
    category: attractions.tours,
    rating: 4.3,
    description:
      "Discover Singapore's unique Jalan Besar precinct and its colourful character. Uncover hidden architectural gems on this two-hour walking tour and pick up some great foodie tips on the way.",
    imgUrl: 'https://www.pelago.co/img/products/SG-Singapore/crimes/0530-0510_0-large.webp',
    price: '20',
    title: 'Jalan Besar Crimes, Clans and Colours Walking Tour',
  },

  {
    id: 37,
    category: attractions.dining,
    rating: 3.4,
    description:
      'Do you know that Koi means "How Are You"? Check out the signature drinks from this Singapore homegrown Bubble Tea Chain well-loved by both locals and travellers.',
    imgUrl: 'https://ntucclubdtecdn.azureedge.net/assets/images/default-source/shop-gallery-/golden-bubble-milk-tea.jpeg?sfvrsn=bda68973_0',
    price: '16',
    title: 'Koi Tea',
  },

  {
    id: 38,
    category: attractions.activities,
    rating: 4.6,
    description:
      "Have you ever wood-fired your very own pizza? Now you can at a three-hour pizza-making experience in the heart of Siglap. A team of food-passionate experience-makers will prepare everything you need, from the dough and toppings to firewood. You can even use plant garnishing that's grown on the rooftop of a shophouse, which you can harvest yourself.",
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/wood-fired-pizza-workshop/0427-0850_wood-fired-pizza-workshop-singapore-pelago0-large.webp',
    price: '26',
    title: 'Fire it Up at a Wood-Fired Oven Pizza-Making Experience',
  },

  {
    id: 39,
    category: attractions.dining,
    rating: 4.3,
    description:
      'Kueh, a bite-sized snack commonly found in Southeast Asia, became the pride and joy of the Peranakan community after they adapted the original Malay and Indonesian versions. At this tasting session, sample a delectable range of traditional Nyonya kueh in a charming Peranakan shophouse, paired with Kim Choo’s signature blue tea.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/nyonya-kueh-sampling-session-kim-choo-kueh-chang-katong/0112-0300_nonya-kueh-sampling-session-singapore-visitor-centre-pelago1-large.webp',
    price: '13',
    title: 'Nyonya Kueh at Kim Choo Kueh Chang',
  },

  {
    id: 40,
    category: attractions.tours,
    rating: 3.5,
    description:
      'Explore the heart of the Lion City cruising one of its main arteries - the Singapore River. Take a 40 minute journey on a traditional Singapore bumboat from Clarke Quay and listen to commentary that reveals the fascinating stories of the many places along the riverside, including Marina Bay Sands and Merlion Park.',
    imgUrl:
      'https://www.pelago.co/img/products/SG-Singapore/singapore-river-cruise/3bec5209-805a-43b9-8c82-f998bfbf8b4a_singapore-river-cruise-large.webp',
    price: '11',
    title: 'Singapore River Cruise Tickets',
  },
];
